import { Route } from 'react-router-dom';
import AuraTemplates from './components/pageComponents/AuraTemplates';
import { useFeatureEntitlements } from '@frontegg/react';
import { PLGUsersCard } from 'src/components/groupComponents/PLGUsersCard';

export const getTemplatesExchangeRoutes = () => {
  const pages = [
    {
      path: '/templatesexchange',
      Component: () => {
        const { isEntitled: templatesExchangeFeature } =
          useFeatureEntitlements('template-exchange');
        if (!templatesExchangeFeature) {
          return <PLGUsersCard />;
        }
        return <AuraTemplates />;
      },
    },
  ];

  return pages.map((route, index) => {
    const { path, Component } = route;
    return <Route key={index} path={path} element={<Component />} />;
  });
};
